import { ReactNode } from "react";
import classNames from "classnames";
import { useHover } from "@mantine/hooks";
import { Link } from "react-router-dom";

import { Badge, Group, Text, ThemeIcon, UnstyledButton } from "@mantine/core";

import { checkActiveLink } from "modules/core/utils/helpers";

import classes from "./styles.module.css";

type SideMenuLinkProps = {
  label: string;
  icon: ReactNode;
  url: string;
  isSoon?: boolean;
  isNew?: boolean;
  isChild?: boolean;
  activeRegex?: RegExp;
};

const SideMenuLink = (props: SideMenuLinkProps) => {
  const { label, icon, url, isNew, isSoon, isChild, activeRegex } = props;

  const isActive = checkActiveLink(url, activeRegex);

  const { ref, hovered } = useHover();

  return (
    <UnstyledButton
      display="block"
      component={Link}
      to={url}
      px="sm"
      py={4}
      pos="relative"
      role="link"
      ref={ref}
      className={classNames(classes.link, {
        [classes.active]: isActive
      })}
    >
      <Group justify="space-between">
        <Group gap="xs">
          <ThemeIcon color={isActive ? "yellow" : isChild ? "gray.5" : "white"}>
            {icon}
          </ThemeIcon>

          <Text
            fz="xs"
            className={classes.label}
            c={isActive ? "yellow" : isChild ? "gray.5" : "white"}
          >
            {label}
          </Text>
        </Group>

        {(isNew || (isSoon && hovered)) && (
          <Badge
            size="xs"
            tt="capitalize"
            variant="light"
            color={isNew ? "green" : "pink"}
            c={isNew ? "green" : "pink.7"}
            fz={9}
            px={4}
            pos="absolute"
            right={4}
          >
            {isNew ? "New" : "Soon"}
          </Badge>
        )}
      </Group>
    </UnstyledButton>
  );
};

export default SideMenuLink;
